/* istanbul ignore file */
import '../resources/less/fonts.css';
import '../resources/tw-gateway.css';
import '../resources/less/dropdowns.css';

import React from 'react';
import { connect } from 'react-redux';
import { Route, Router, Switch } from 'react-router-dom';
import * as _ from 'lodash';
import Callback from '../components/Callback';
import history from '../history';
import CigServStandaloneLoadingPage from './CigServStandaloneLoadingPage';
import CigServLoadingPage from './CigServLoadingPage';
import CigSSONav from './CigSSONav';
import CigRoot from './CigRoot';
import CigLogout from './CigLogout';

import CigAcceptInvitation from '../pages/invite/CigAcceptInvitation';
import CigTenantCreationPage from './CigTenantCreationPage';
import { configErrorMessage } from './selectors';
import ErrorPage from '../components/error/ErrorPage';
import {CIG_SSO, AUTH0, PAGE_NOT_FOUND_QUERY_KEY} from '../common/constants';
import {getQueryStringParam, isServiceLogoutUri, isStandaloneMode, redirectToNetAppConsoleHome, shouldRedirectToNetAppConsole} from '../common/utils';
import CigLogoutPage from './CigLogoutPage';
import ErrorWrapperPage from '../components/error/ErrorWrapperPage';
import CigAuthLogin from './CigAuthLogin';
import Profile from '../pages/profile/Profile';
import {PageNotFoundMessage} from '../components/error/ErrorMessagesComps';


window.auth = '';


export function CigApp(props) {
    if (shouldRedirectToNetAppConsole()) {
        if (redirectToNetAppConsoleHome()) {
            return <div id="empty-start-page"></div>;
        }
        window.CIG_LOG.warn('Gateway: standalone UI disabled but netAppConsoleUrl is missing; continuing app bootstrap.');
    }

    if (window.CIG.authProvider === AUTH0 && _.isEmpty(window.auth)) {
        return <div id="empty-start-page"></div>;
    }

    if (!_.isNil(window.history.state) && !_.isNil(window.history.state[CIG_SSO.historyState])) {
        window.history.forward();
    }

    return (
        <div>
            {
                !_.isUndefined(props.errorMessage) && (
                    <ErrorPage id="start-app-error" message={props.errorMessage} serverMsg={props.errorMessage} auth={window.auth}/>
                )
            }
            {
                _.isUndefined(props.errorMessage) && (
                    <Router history={history}>
                        <div>
                            <Switch>
                                <Route exact path="/" render={(props) => {
                                    if (isServiceLogoutUri()) {
                                        return <CigLogoutPage auth={window.auth} {...props} />
                                    }
                                    else
                                        return <CigRoot auth={window.auth} {...props} />;
                                }}/>
                                <Route exact path="/logout/tenant" render={(props) => {
                                    return <CigLogout auth={window.auth} {...props} />;
                                }}/>
                                <Route exact path="/logout/csecure" render={(props) => {
                                    return <CigLogout auth={window.auth} {...props} />;
                                }}/>
                                <Route exact path="/auth/login" render={(props) => {
                                    return <CigAuthLogin auth={window.auth} {...props} />;
                                }}/>
                                <Route exact path="/service" render={(props) => {
                                    if (isStandaloneMode()) {
                                        return <CigServStandaloneLoadingPage auth={window.auth} {...props} />;
                                    }
                                    else {
                                        return <CigServLoadingPage auth={window.auth} {...props} />;
                                    }
                                }}/>
                                <Route exact path="/service/cm" render={(props) => {
                                    return <CigServStandaloneLoadingPage auth={window.auth} {...props} />;
                                }}/>
                                <Route exact path="/login/tenantnav" render={(props) => {
                                    return <CigSSONav auth={window.auth} {...props} />;
                                }}/>
                                <Route exact path="/acceptInvite" render={(props) => {
                                    return <CigAcceptInvitation auth={window.auth} {...props} />;
                                }}/>
                                <Route exact path="/createTenant" render={(props) => {
                                    return <CigTenantCreationPage auth={window.auth} {...props} />;
                                }}/>
                                <Route exact path="/callback" render={(props) => {
                                    return <Callback bg={'white'} {...props} />
                                }}/>
                                <Route exact path="/error/redirect" render={(props) => {
                                    return <ErrorWrapperPage id="error-wrapper-redirect" auth={window.auth} {...props} />
                                }}/>
                                <Route exact path="/error/login" render={(props) => {
                                    return <ErrorWrapperPage id="error-wrapper-login" auth={window.auth} {...props} />
                                }}/>
                                <Route exact path="/error/auth" render={(props) => {
                                    return <ErrorPage id="auth-error"
                                        title={'We encountered a problem accessing your Data Infrastructure Insights Tenant.'}
                                        message="Please try again later." auth={window.auth}
                                        serverMsg={props.errorMessage}
                                        logPrefix={'CigApp: /error/auth'}/>
                                }}/>
                                <Route exact path="/error/notfound" render={(props) => {
                                    const loc = getQueryStringParam(PAGE_NOT_FOUND_QUERY_KEY) || '';
                                    const notFoundUrl = window.location.origin + (_.isEmpty(loc) ? '' : atob(loc));

                                    return <ErrorPage id="url-error" title="Page can’t be found." showLogout={false}
                                        support={false}
                                        auth={window.auth} serverMsg={props.errorMessage}
                                        logPrefix={'CigApp: /error/notfound'}>
                                        <PageNotFoundMessage notFoundUrl={notFoundUrl}/>
                                    </ErrorPage>
                                }}/>
                                <Route exact path="/oci/profile" render={(props) => {
                                    return <Profile auth={window.auth}  {...props} />
                                }}/>
                            </Switch>
                        </div>
                    </Router>
                )
            }
        </div>
    );
}

CigApp.displayName = 'CigApp';
function mapStateToProps(state){
    return {
        errorMessage: configErrorMessage(state),
    }
}

export default connect(mapStateToProps)(CigApp);
